/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgUnderlineP = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M711 1163v629H512V128h466q121 0 225 28t181 89 121 154 44 226q0 134-49 235t-134 168-196 101-236 34H711zm0-859v683h208q87 0 163-19t134-61 91-109 34-164q0-94-30-157t-84-101-125-55-158-17H711zM512 2048v-128h1024v128H512z"
    }));
export default SvgUnderlineP;
